import React from "react";

import { useTranslation } from "react-i18next";

import { usePartnerInfo } from "@utils";

import { Box, Button, Icon, Text, Title } from "@ui/elements";
import { Stack } from "@ui/layout";

export const ContactChatBox = () => {
  const { t } = useTranslation();
  const partnerInfo = usePartnerInfo();

  return (
    <Box>
      <Stack align="center">
        <Icon icon="ChatCircleDots" size="large" />
        <Stack direction="column" gap="none" isFullwidth>
          <Title size={5}>{t("need-help")}</Title>
          <Text variant="secondary">{t("were-here")}</Text>
        </Stack>

        <Stack>
          {partnerInfo.contact.telegram && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={partnerInfo.contact.telegram}
              target="_blank"
            >
              <Icon icon="TelegramLogo" />
            </Button>
          )}

          {partnerInfo.contact.instagram && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={partnerInfo.contact.instagram}
              target="_blank"
            >
              <Icon icon="InstagramLogo" />
            </Button>
          )}

          {partnerInfo.contact.email && (
            <Button
              variant="light"
              isRounded
              as="link"
              href={`mailto:${partnerInfo.contact.email}`}
              target="_blank"
            >
              <Icon icon="At" />
            </Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
